import React, { Fragment, useState, useEffect } from "react";
import { Row, Col, Form, Button, Toast, Modal } from "react-bootstrap";
import DatePicker from "react-datepicker";
import {
	IoIosClose,
	IoMdDownload,
	IoMdDoneAll,
	IoMdCreate,
	IoMdCalendar,
	IoMdTrash,
} from "react-icons/io";
import ReactTable from "../../../../components/FilterTable";
import { _HttpServices } from "../../../../_services/_HttpServices";
import Loader from "../../../../components/Loader";
import moment from "moment";
import { useHistory } from "react-router";
import getExcel from "../../../../_services/ExcelUtility";
import { Footer } from "../../../../components/Footer";

const SalesEdiAddEdit = (props) => {
	let fileName = "";
	const outbounddata = JSON.parse(localStorage.getItem("outboundreport"));
	const salesData = JSON.parse(localStorage.getItem("salesData"));
	fileName = `${outbounddata.VendorName} Sales Source Data (EDI)`;

	const userData = localStorage.getItem("userData");
	const history = useHistory();
	const [sales, setSales] = useState([]);
	const [gridSales, setGridSales] = useState([]);
	const [loading, setLoading] = useState(false);
	const [hasError, setHasError] = useState(false);
	const [showCOnfirm, setShowConfirm] = useState(false);
	const [addshowConfirm, setaddShowConfirm] = useState(false);
	const [gridShow, setGridShow] = useState(false);
	const [sale, setSaleItem] = useState({});
	const [editOrSaveInd, setEditOrSaveInd] = useState(false);
	const [disableSubmit, setSubmitDisable] = useState(false);
	const [addDisableSubmit, setAddSubmitDisable] = useState(false);
	const [showToaster, setShowToaster] = useState(false);
	const [disableSaveAll, setDisableSaveAll] = useState(false);
	const initialvalues = {
		ContractReference: "",
		ShippedQuantity: "",
		ShippedMeasurementCode: "",
		ShippedDate: "",
		ShippedTime: "",
		InvoiceNumber: "",
		ShipFromName: "",
		ShipToName: "",
		ShipFromCustomerID: "",
		ShipToCustomerID: "",
		VendorCustomerID: "",
		TotalInvoiceAmount: "",
		PurchaseOrderNumber: "",
		QuantityInvoiced: "",
		InvoicedUnitMeasurementCode: "",
		InvoicedUnitPrice: "",
		InvoicedUnitPriceCode: "",
		BuyerPartNumber: "",
		VendorPartNumber: "",
		UPC: "",
		Pack: "",
		Size: "",
		PackagingCode: "",
	};
	const [newSales, setNewSales] = useState(initialvalues);
	const [editIndex, setEditIndex] = useState();

	const Gridcolumns = [
		{
			Header: "Actions",
			accessor: "accessor",
			disableFilters: true,
			disableSortBy: true,
			width: 130,
			accessor: "accessor",

			Cell: (row) => (
				<Fragment>
					<Button
						variant="link"
						onClick={() => editReport(row)}
						className="grid-action-btn ml-2"
						title="Edit Row"
					>
						<IoMdCreate className="icon" />
					</Button>
					<Button
						variant="link"
						onClick={() => deleteRecord(row)}
						className="grid-action-btn ml-2"
						title="Delete Row"
					>
						<IoMdTrash className="icon fa-icon" />
					</Button>
				</Fragment>
			),
		},
		{
			Header: "Contract Reference",
			accessor: "ContractReference",
			filter: "ContractReference",
			sortType: "basic",
			width: 250,
			key: true,
		},
		{
			Header: "Shipped Quantity",
			accessor: "ShippedQuantity",
			filter: "ShippedQuantity",
			sortType: "basic",
			width: 80,
			key: true,
		},
		{
			Header: "Shipped Measurement Code",
			accessor: "ShippedMeasurementCode",
			filter: "ShippedMeasurementCode",
			sortType: "basic",
			width: 80,
			key: true,
		},
		{
			Header: "Shipped Date",
			accessor: "ShippedDate",
			filter: "ShippedDate",
			sortType: "basic",
			width: 120,
			key: true,
		},
		{
			Header: "Shipped Time",
			accessor: "ShippedTime",
			filter: "ShippedTime",
			sortType: "basic",
			width: 120,
			key: false,
			disable: true,
		},
		{
			Header: "Invoice Number #",
			accessor: "InvoiceNumber",
			filter: "InvoiceNumber",
			sortType: "basic",
			width: 150,
			key: true,
		},
		{
			Header: "Ship From Name",
			accessor: "ShipFromName",
			filter: "ShipFromName",
			sortType: "basic",
			width: 250,
			key: true,
		},
		{
			Header: "Ship To Name",
			accessor: "ShipToName",
			filter: "ShipToName",
			sortType: "basic",
			width: 350,
			key: true,
		},
		{
			Header: "Ship From CustomerID ",
			accessor: "ShipFromCustomerID",
			filter: "ShipFromCustomerID",
			sortType: "basic",
			width: 80,
			key: true,
		},
		{
			Header: "Ship To CustomerID",
			accessor: "ShipToCustomerID",
			filter: "ShipToCustomerID",
			sortType: "basic",
			width: 80,
			key: true,
		},
		{
			Header: "Vendor CustomerID",
			accessor: "VendorCustomerID",
			filter: "VendorCustomerID",
			sortType: "basic",
			width: 80,
			key: true,
		},
		{
			Header: "Total Invoice Amount",
			accessor: "TotalInvoiceAmount",
			filter: "TotalInvoiceAmount",
			sortType: "basic",
			width: 120,
			key: true,
		},

		{
			Header: "Purchase Order Number",
			accessor: "PurchaseOrderNumber",
			filter: "PurchaseOrderNumber",
			sortType: "basic",
			width: 180,
			key: true,
		},
		{
			Header: "Quantity Invoiced",
			accessor: "QuantityInvoiced",
			filter: "QuantityInvoiced",
			sortType: "basic",
			width: 80,
			key: true,
		},
		{
			Header: "Invoiced Unit Measurement Code",
			accessor: "InvoicedUnitMeasurementCode",
			filter: "InvoicedUnitMeasurementCode",
			sortType: "basic",
			width: 80,
			key: true,
		},
		{
			Header: "Invoiced Unit Price",
			accessor: "InvoicedUnitPrice",
			filter: "InvoicedUnitPrice",
			sortType: "basic",
			width: 80,
			key: true,
		},
		{
			Header: "Invoiced Unit Price Code",
			accessor: "InvoicedUnitPriceCode",
			filter: "InvoicedUnitPriceCode",
			sortType: "basic",
			width: 80,
			key: true,
		},
		{
			Header: "Buyer Part Number",
			accessor: "BuyerPartNumber",
			filter: "BuyerPartNumber",
			sortType: "basic",
			width: 150,
			key: true,
		},

		{
			Header: "Vendor Part Number",
			accessor: "VendorPartNumber",
			filter: "VendorPartNumber",
			sortType: "basic",
			width: 150,
			key: true,
		},
		{
			Header: "UPC",
			accessor: "UPC",
			filter: "UPC",
			sortType: "basic",
			width: 150,
			key: true,
		},
		{
			Header: "Pack",
			accessor: "Pack",
			filter: "Pack",
			sortType: "basic",
			width: 80,
			key: true,
		},
		{
			Header: "Size",
			accessor: "Size",
			filter: "Size",
			sortType: "basic",
			width: 80,
			key: true,
		},
		{
			Header: "Packaging Code",
			accessor: "PackagingCode",
			filter: "PackagingCode",
			sortType: "basic",
			width: 80,
			key: true,
		},
	];

	useEffect(() => {
		setGridSales(salesData);
	}, []);

	const handleChange = (e) => {
		const { name, value } = e.target;
		if (
			name === "BuyerPartNumber" ||
			name === "FileProcessID" ||
			name === "InvoiceNumber" ||
			name === "InvoicedUnitPrice" ||
			name === "ChargebackAmount" ||
			name === "Pack" ||
			name === "QuantityInvoiced" ||
			name === "ShipFromCustomerID" ||
			name === "ShipToCustomerID" ||
			name === "ShippedQuantity" ||
			name === "Size" ||
			name === "TotalInvoiceAmount" ||
			name === "TotalLineCount" ||
			name === "VendorCustomerID" ||
			name === "VendorPartNumber" ||
			name === "Pack"
		) {
			const re = /^[($)\d\.,-]+$/;
			if (value === "" || re.test(value)) {
				setSaleItem((values) => ({
					...values,
					[name]: value.trim(),
				}));
			}
		} else {
			setSaleItem((values) => ({
				...values,
				[name]: value.replace(/\s{2,}/g, " "),
			}));
		}
	};

	const newhandleChange = (e) => {
		const { name, value } = e.target;
		if (
			name === "BuyerPartNumber" ||
			name === "FileProcessID" ||
			name === "InvoiceNumber" ||
			name === "InvoicedUnitPrice" ||
			name === "ChargebackAmount" ||
			name === "Pack" ||
			name === "QuantityInvoiced" ||
			name === "ShipFromCustomerID" ||
			name === "ShipToCustomerID" ||
			name === "ShippedQuantity" ||
			name === "Size" ||
			name === "TotalInvoiceAmount" ||
			name === "TotalLineCount" ||
			name === "VendorCustomerID" ||
			name === "VendorPartNumber" ||
			name === "Pack"
		) {
			const re = /^[($)\d\.,-]+$/;
			if (value === "" || re.test(value)) {
				setNewSales((values) => ({
					...values,
					[name]: value.trim(),
				}));
			}
		} else {
			setNewSales((values) => ({
				...values,
				[name]: value.replace(/\s{2,}/g, " "),
			}));
		}
	};

	function deleteRecord(row) {
		console.log(row.row.original);
		let data = gridSales.filter((element, index) => {
			return index !== row.row.index;
		});
		const deletedData = Object.assign([], data);
		setGridSales(deletedData);
	}

	useEffect(() => {
		setSubmitDisable(validateForm());
	}, [newSales]);
	useEffect(() => {
		setAddSubmitDisable(validateEditForm());
	}, [sale]);

	const validateEditForm = () => {
		if (
			sale.ContractReference &&
			sale.ContractReference.toString().trim() !== "" &&
			(sale.ShippedQuantity || sale.ShippedQuantity === 0) &&
			sale.ShippedQuantity.toString().trim() !== "" &&
			sale.ShippedMeasurementCode &&
			sale.ShippedMeasurementCode.toString().trim() !== "" &&
			sale.InvoiceNumber &&
			sale.InvoiceNumber.toString().trim() !== "" &&
			sale.ShipFromName &&
			sale.ShipFromName.toString().trim() !== "" &&
			sale.ShipToName &&
			sale.ShipToName.toString().trim() !== "" &&
			sale.ShipFromCustomerID &&
			sale.ShipFromCustomerID.toString().trim() !== "" &&
			sale.ShipToCustomerID &&
			sale.ShipToCustomerID.toString().trim() !== "" &&
			sale.VendorCustomerID &&
			sale.VendorCustomerID.toString().trim() !== "" &&
			sale.TotalInvoiceAmount &&
			sale.TotalInvoiceAmount.toString().trim() !== "" &&
			sale.PurchaseOrderNumber &&
			sale.PurchaseOrderNumber.toString().trim() !== "" &&
			(sale.QuantityInvoiced || sale.QuantityInvoiced === 0) &&
			sale.QuantityInvoiced.toString().trim() !== "" &&
			sale.InvoicedUnitMeasurementCode &&
			sale.InvoicedUnitMeasurementCode.toString().trim() !== "" &&
			sale.InvoicedUnitPrice &&
			sale.InvoicedUnitPrice.toString().trim() !== "" &&
			sale.InvoicedUnitPriceCode &&
			sale.InvoicedUnitPriceCode.toString().trim() !== "" &&
			sale.BuyerPartNumber &&
			sale.BuyerPartNumber.toString().trim() !== "" &&
			sale.VendorPartNumber &&
			sale.VendorPartNumber.toString().trim() !== "" &&
			sale.UPC &&
			sale.UPC.toString().trim() !== "" &&
			sale.Pack &&
			sale.Pack.toString().trim() !== "" &&
			sale.Size &&
			sale.Size.toString().trim() !== "" &&
			sale.PackagingCode &&
			sale.PackagingCode.toString().trim() !== ""
		) {
			return false;
		} else {
			return true;
		}
	};

	const validateForm = () => {
		if (
			newSales.ContractReference &&
			newSales.ContractReference.toString().trim() !== "" &&
			(newSales.ShippedQuantity || newSales.ShippedQuantity === 0) &&
			newSales.ShippedQuantity.toString().trim() !== "" &&
			newSales.ShippedMeasurementCode &&
			newSales.ShippedMeasurementCode.toString().trim() !== "" &&
			newSales.InvoiceNumber &&
			newSales.InvoiceNumber.toString().trim() !== "" &&
			newSales.ShipFromName &&
			newSales.ShipFromName.toString().trim() !== "" &&
			newSales.ShipToName &&
			newSales.ShipToName.toString().trim() !== "" &&
			newSales.ShipFromCustomerID &&
			newSales.ShipFromCustomerID.toString().trim() !== "" &&
			newSales.ShipToCustomerID &&
			newSales.ShipToCustomerID.toString().trim() !== "" &&
			newSales.VendorCustomerID &&
			newSales.VendorCustomerID.toString().trim() !== "" &&
			newSales.TotalInvoiceAmount &&
			newSales.TotalInvoiceAmount.toString().trim() !== "" &&
			newSales.PurchaseOrderNumber &&
			newSales.PurchaseOrderNumber.toString().trim() !== "" &&
			(newSales.QuantityInvoiced || newSales.QuantityInvoiced === 0) &&
			newSales.QuantityInvoiced.toString().trim() !== "" &&
			newSales.InvoicedUnitMeasurementCode &&
			newSales.InvoicedUnitMeasurementCode.toString().trim() !== "" &&
			newSales.InvoicedUnitPrice &&
			newSales.InvoicedUnitPrice.toString().trim() !== "" &&
			newSales.InvoicedUnitPriceCode &&
			newSales.InvoicedUnitPriceCode.toString().trim() !== "" &&
			newSales.BuyerPartNumber &&
			newSales.BuyerPartNumber.toString().trim() !== "" &&
			newSales.VendorPartNumber &&
			newSales.VendorPartNumber.toString().trim() !== "" &&
			newSales.UPC &&
			newSales.UPC.toString().trim() !== "" &&
			newSales.Pack &&
			newSales.Pack.toString().trim() !== "" &&
			newSales.Size &&
			newSales.Size.toString().trim() !== "" &&
			newSales.PackagingCode &&
			newSales.PackagingCode.toString().trim() !== ""
		) {
			return false;
		} else {
			return true;
		}
	};

	function saveRowHandler() {
		if (!editOrSaveInd) {
			newSales.ShippedDate = moment(
				newSales.ShippedDate ? newSales.ShippedDate : new Date()
			).format("MM/DD/YYYY");
			newSales.ind = Object.assign({}, gridSales.length + 1);
			newSales.ind = gridSales.length + 1;
			const ns = Object.assign({}, newSales);
			gridSales.unshift(ns);
			setaddShowConfirm(false);
			setNewSales(initialvalues);
			newSales.ind = 0;
		}
	}

	function editRowHandler() {
		let indicator = 0;
		sale.ShippedDate = moment(sale.ShippedDate).format("MM/DD/YYYY");

		if (editOrSaveInd) {
			gridSales.filter((element, index) => {
				if (editIndex === index) {
					const saletemp = Object.assign({}, sale);
					gridSales[index] = saletemp;
				}
			});
			indicator = 1;
		}

		if (indicator !== 0) {
			console.log(sale);
			setShowConfirm(false);
		}
	}

	const editReport = (sales) => {
		setEditIndex(sales.row.index);
		setSaleItem(
			{
				...sale,
				...sales.row.original,
			},
			setAddSubmitDisable(validateEditForm())
		);
		setShowConfirm(true);
		setEditOrSaveInd(true);
		setAddSubmitDisable(validateEditForm());
	};

	const EditRecords = () => {
		setGridShow(true);
	};

	const saveRecords = () => {
		setaddShowConfirm(true);
		setEditOrSaveInd(false);
	};

	const saveallRecords = () => {
		setDisableSaveAll(true);
		gridSales.map((element) => {
			element.FileProcessID = salesData[0].FileProcessID;
			element.ModifiedOn = new Date();
			element.LastModifiedBy = JSON.parse(userData).UserName;
			element.IsResendRequired =
				outbounddata.FileSentStatus === "Sent" ? true : false;
			element.IsReadyforReversalStatus = true;
			element.IsEdited = true;
			element.Version = 1;
			element.Service_Task_Id = outbounddata.ServiceTaskID;

			element.DistributorName = "";
			element.DistributionLocationState = "";
			element.ReportDate = "";
			element.DebitMemoNum = "";
			element.CustID = "";
			element.CustPHSID = "";
			element.CustName = "";
			element.CustAddress = "";
			element.CustCity = "";
			element.CustState = "";
			element.CustZip = "";
			element.CustomersInvoice = "";
			element.CustomersInvoiceDate = "";
			element.ProductNDC = "";
			element.ProductDescription = "";
			element.SaleQTY = "";
			element.SaleQTYUOM = "";
			element.DosagORUnitstabs30 = "";
			element.DosageORUnitsUMO = "";
			element.Totalcount = "";
			element.AcquisitionCost = "";
			element.ContractPrice = "";
			element.ADMFees40 = "";
			element.ADMFees5 = "";
			element.ADMFees70 = "";
			element.ADMFees30 = "";
			element.CIBDExtendedAmount = "";
			element.AccountAddress2 = "";
			element.ProductNDCType = "";
			element.RefIDType = "";
			element.ProductTransferIndicator = "";
			element.DropShippedIndicator = "";
			element.DistributorBranchCity = "";
			element.TwoPercentServiceFees = "";
			element.Version_File = "1";
			element.PhysicianLastName = "";
			element.PhysicianFirstName = "";
		});

		setLoading(true);
		_HttpServices
			.postData("Api/Edi844/EDI857ServiceFeesReport", gridSales)
			.then((data) => {
				if (data.data === "") {
					setShowToaster(true);
					setTimeout(() => history.push("/outbound-reports"), 1000);
					setLoading(false);
				}
			})
			.catch((e) => {
				setLoading(false);
				setDisableSaveAll(false);
			});
	};

	return (
		<section className="content">
			<div className="page-title">
				<h2 className="h2">{fileName}</h2>
				{loading ? <Loader /> : null}
				<Toast
					onClose={() => setShowToaster(false)}
					show={showToaster}
					delay={1500}
					autohide
					className="custom-toaster"
				>
					<Toast.Body>Details updated successfully</Toast.Body>
				</Toast>
				<div>
					{!gridShow && (
						<Button
							variant="primary"
							type="button"
							onClick={() => saveRecords()}
						>
							Add Record
						</Button>
					)}
					<Button
						className="ml-2"
						type="submit"
						onClick={() => getExcel(Gridcolumns, gridSales, fileName)}
					>
						<IoMdDownload className="icon btn-icon" />
						Download Excel{" "}
					</Button>
				</div>

				{/* Add New Record Modal */}
				<Modal
					show={addshowConfirm}
					onHide={() => setaddShowConfirm(false)}
					backdrop="static"
					keyboard={false}
					size="lg"
				>
					<Modal.Header closeButton>
						<Modal.Title>Add Record</Modal.Title>
					</Modal.Header>

					<Modal.Body>
						<Row>
							<Col md={12}>
								<div className="card pt-2 mb-4">
									<div className="card-body">
										<Form>
											<Row>
												{Gridcolumns.map(function (i, index) {
													return (
														i.accessor !== "accessor" && (
															<Col md={3} key={index}>
																<Form.Group>
																	<div className="date-picker ungroup-date-picker pos-rl">
																		<Form.Label htmlFor="StartDate">
																			{i.accessor !== "accessor"
																				? i.Header
																				: ""}
																			{i.key && (
																				<span className="err-msg">*</span>
																			)}
																		</Form.Label>
																		{i.Header.indexOf("Date") !== -1 && (
																			<IoMdCalendar className="icon date-icon" />
																		)}
																		{i.Header.indexOf("Date") !== -1 && (
																			<DatePicker
																				key={newSales[i.accessor]}
																				selected={
																					newSales[i.accessor]
																						? new Date(
																								moment(
																									newSales[i.accessor]
																								).format("MM/DD/YYYY")
																						  )
																						: new Date()
																				}
																				onChange={(e) =>
																					setNewSales((values) => ({
																						...values,
																						[i.accessor]: e,
																					}))
																				}
																				maxDate={new Date()}
																			/>
																		)}
																		{i.Header.indexOf("Date") === -1 && (
																			<Form.Control
																				required
																				type="text"
																				name={i.accessor}
																				value={newSales[i.accessor]}
																				key={sale[i.accessor]}
																				onChange={(e) => newhandleChange(e)}
																				disabled={i.disable}
																			/>
																		)}
																	</div>
																</Form.Group>
															</Col>
														)
													);
												})}
											</Row>
										</Form>
									</div>
								</div>
							</Col>
						</Row>
					</Modal.Body>
					<Modal.Footer>
						<div className="text-right mt-2">
							<Button
								type="submit"
								disabled={disableSubmit}
								onClick={() => saveRowHandler()}
							>
								<IoMdDoneAll className="icon btn-icon" />
								Save
							</Button>
							<Button
								variant="danger"
								className="ml-3 btn-sm"
								onClick={() => {
									setaddShowConfirm(false);
									setNewSales(initialvalues);
								}}
							>
								<IoIosClose className="icon btn-icon" />
								Cancel
							</Button>
						</div>
					</Modal.Footer>
				</Modal>

				{/* Edit Existing Record MOdal */}
				<Modal
					show={showCOnfirm}
					onHide={() => setShowConfirm(false)}
					backdrop="static"
					keyboard={false}
					size="lg"
				>
					<Modal.Header closeButton>
						<Modal.Title>Edit Record</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<Row>
							<Col md={12}>
								<div className="card pt-2 mb-4">
									<div className="card-body">
										<Form>
											<Row>
												{Gridcolumns.map(function (i, index) {
													return (
														i.accessor !== "accessor" && (
															<Col md={3} key={index}>
																<Form.Group>
																	<div className="date-picker ungroup-date-picker pos-rl">
																		<Form.Label htmlFor="StartDate">
																			{i.accessor !== "accessor"
																				? i.Header
																				: ""}
																			{i.key && (
																				<span className="err-msg">*</span>
																			)}
																		</Form.Label>
																		{i.Header.indexOf("Date") !== -1 && (
																			<IoMdCalendar className="icon date-icon" />
																		)}
																		{i.Header.indexOf("Date") !== -1 && (
																			<DatePicker
																				key={sale[i.accessor]}
																				selected={
																					sale[i.accessor]
																						? new Date(
																								moment(sale[i.accessor]).format(
																									"MM/DD/YYYY"
																								)
																						  )
																						: new Date()
																				}
																				onChange={(e) =>
																					setSaleItem((values) => ({
																						...values,
																						[i.accessor]: e,
																					}))
																				}
																				maxDate={new Date()}
																			/>
																		)}
																		{i.Header.indexOf("Date") === -1 && (
																			<Form.Control
																				required
																				type="text"
																				name={i.accessor}
																				value={sale[i.accessor]}
																				// key={cont[i.accessor]}
																				onChange={(e) => handleChange(e)}
																				disabled={i.disable}
																			/>
																		)}
																	</div>
																</Form.Group>
															</Col>
														)
													);
												})}
											</Row>
										</Form>
									</div>
								</div>
							</Col>
						</Row>
					</Modal.Body>
					<Modal.Footer>
						<div className="text-right mt-2">
							<Button
								disabled={addDisableSubmit}
								onClick={() => editRowHandler()}
							>
								<IoMdDoneAll className="icon btn-icon" />
								Edit Row
							</Button>
							<Button
								variant="danger"
								className="ml-3 btn-sm"
								onClick={() => setShowConfirm(false)}
							>
								<IoIosClose className="icon btn-icon" />
								Cancel
							</Button>
						</div>
					</Modal.Footer>
				</Modal>
			</div>

			{gridShow && (
				<Row>
					<Col md={12}>
						<div className="card pt-2">
							<div className="card-body">
								<div className="inventory-grid">
									{hasError ? (
										<p>Error occurred. Unable to load {fileName}</p>
									) : (
										<Fragment>
											{sales.length > 0 ? (
												<ReactTable
													columns={Gridcolumns}
													data={sales}
													defaultPageSize={10}
												/>
											) : (
												<div className="no-data">No data found.</div>
											)}
										</Fragment>
									)}
								</div>
							</div>
						</div>
					</Col>
				</Row>
			)}
			{!gridShow && (
				<Row>
					<Col md={12}>
						<span className="mb-4 h6">
							File Name: {outbounddata.File_Process_Name}
						</span>{" "}
						<span className="ml-4 h6">Version: {outbounddata.Fileversion}</span>
						<div className="card pt-2">
							<div className="card-body">
								<div className="inventory-grid">
									{hasError ? (
										<p>Error occurred. Unable to load {fileName}</p>
									) : (
										<Fragment>
											{gridSales.length > 0 ? (
												<ReactTable
													columns={Gridcolumns}
													data={gridSales}
													defaultPageSize={10}
												/>
											) : (
												<div className="no-data">No data found.</div>
											)}
										</Fragment>
									)}
								</div>
							</div>
						</div>
					</Col>
				</Row>
			)}
			<Row>
				<Col md={12} className="text-right mt-2">
					{gridSales.length > 0 && (
						<Button
							variant="primary"
							type="button"
							disabled={disableSaveAll}
							onClick={() => saveallRecords()}
						>
							Save Records
						</Button>
					)}
					<Button
						variant="danger"
						type="button"
						className="ml-3"
						onClick={() => history.goBack()}
					>
						<IoIosClose className="icon btn-icon" />
						Cancel
					</Button>
				</Col>
			</Row>
			<Footer />
		</section>
	);
};

export default SalesEdiAddEdit;
